export default __webpack_public_path__ + "static/media/iPhone_campaign_cropped.26a28f58.png";